import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-mantenimiento',
  standalone: false,
  templateUrl: './mantenimiento.component.html',
  styleUrl: './mantenimiento.component.scss'
})
export class MantenimientoComponent {
  @Input() imgMarca: string = "";
}
